import parseDecimalNumber from 'parse-decimal-number'

const germanSeparators = {
  thousands: '.',
  decimal: ',',
};

export function parseDecimal(value: string): number;
export function parseDecimal(value: string | undefined): number | undefined;
export function parseDecimal(value: string | undefined): number | undefined {
  if (value == null || value.trim() === '') {
    return undefined;
  }

  return parseDecimalNumber(value, germanSeparators);
}



// WEBPACK FOOTER //
// ./src/shared/ParseDecimal.ts